<template>
    <div class="full-content" style="background-image:url('assets/img/bg-gaspol-1.jpg');">
        <div class="card bg-card-trans border-0 rounded-0 mobile-ver">
            <div v-if="dataFetch">
                <p class="text-center mt-5">Loading...</p>
            </div>
            <div v-if="!dataFetch">
                <div class="mobile-ver-top mobile-ver-top-2">
                    <div class="d-flex align-items-center h-100 justify-content-between px-3">
                        <div class="d-flex align-items-center">
                            <a href="javascript:void(0)" class="btn btn-white-naked btn-icon me-md-3 me-2"
                                v-on:click="goToPage('dashboard_student')">
                                <i class="fa-solid fa-arrow-left"></i>
                            </a>
                            <div class="d-block display-tektur h1 m-0">Profil Siswa</div>
                        </div>
                        <div class="pe-3">
                            <div class="hide-767">
                                <button v-on:click="saveProfile" type="button" class="btn btn-s-1 btn-primary" :disabled="(form.new_password != form.retype_password && form.retype_password != '')">
                                    <div class="btn-s-1-inner"><i class="fa-solid fa-save me-2"></i>{{ waiting ? 'Harap tunggu ...' : 'Simpan' }}</div>
                                </button>
                            </div>
                            <div class="show-767">
                                <button v-on:click="saveProfile" type="button" class="btn btn-s-1 btn-sm btn-primary" :disabled="(form.new_password != form.retype_password && form.retype_password != '')">
                                    <div class="btn-s-1-inner"><i class="fa-solid fa-save me-2"></i>{{ waiting ? 'Harap tunggu ...' : 'Simpan' }}</div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mobile-ver-content--has-simplebar mobile-ver-content-2 full-bottom">
                    <div class="d-block px-md-4 px-3 pt-md-4 pt-3">
                        <div class="row mb-4">
                            <div class="col-6 m-0">
                                <div class="card h-100 m-0">
                                    <div class="card-body">
                                        <div class="d-block text-neon h2 mb-3 display-tektur">Pilihan 1</div>
                                        <div class="d-block">
                                            <div class="font-bold block-ellipsis">{{ dataUsers.rationalization.major_one }}</div>
                                            <div class="d-block text-sm block-ellipsis">{{ dataUsers.rationalization.university_one }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="card h-100 m-0">
                                    <div class="card-body">
                                        <div class="d-block text-neon h2 mb-3 display-tektur">Pilihan 2</div>
                                        <div class="d-block">
                                            <div class="font-bold block-ellipsis">{{ dataUsers.rationalization.major_two }}</div>
                                            <div class="d-block text-sm block-ellipsis">{{ dataUsers.rationalization.university_two }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card mb-4">
                            <div class="card-body">
                                <div class="d-block h2 mb-4"><span class="display-tektur text-neon">Identitas</span></div>
                                <div class="d-block mb-4">
                                    <div class="d-block font-bold text-sm mb-2">Nama Lengkap</div>
                                    <div class="input-icon mb-3">
                                        <input class="form-control m-0" type="text" placeholder="Masukan nama lengkap" v-model="form.fullname">
                                        <i class="fa-solid fa-user text-muted"></i>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-7 col-6">
                                        <div class="d-block">
                                            <div class="d-block font-bold text-sm mb-2">NISN</div>
                                            <div class="input-icon mb-3">
                                                <input class="form-control m-0" type="text" placeholder="Masukan NISN"
                                                    value="" readonly v-model="form.identity_number">
                                                <i class="fa-solid fa-address-card text-muted"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-5 col-6">
                                        <div class="d-block">
                                            <div class="d-block font-bold text-sm mb-2">Kelas</div>
                                            <div class="input-icon mb-3">
                                                <input class="form-control m-0" type="text" placeholder="Masukan kelas" v-model="form.class">
                                                <i class="fa-solid fa-graduation-cap text-muted"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-block small text-muted pt-3">Mohon untuk mengisi data dengan benar & lengkap
                                </div>
                            </div>
                        </div>
                        <div class="card mb-4">
                            <div class="card-body">
                                <div class="d-block h2 mb-4"><span class="display-tektur text-neon">Pengaturan Kata
                                        Sandi</span></div>
                                <div class="d-block mb-4">
                                    <div class="d-block font-bold text-sm mb-2">Kata Sandi Lama</div>
                                    <div class="input-icon mb-3">
                                        <input class="form-control m-0" type="text" placeholder="Masukan kata sandi" v-model="form.old_password">
                                        <i class="fa-solid fa-lock text-muted"></i>
                                    </div>
                                </div>
                                <div class="d-block mb-4">
                                    <div class="d-block font-bold text-sm mb-2">Kata Sandi Baru</div>
                                    <div class="input-icon mb-3">
                                        <input class="form-control m-0" type="text" placeholder="Masukan kata sandi" v-model="form.new_password">
                                        <i class="fa-solid fa-lock text-muted"></i>
                                    </div>
                                </div>
                                <div class="d-block">
                                    <div class="d-block font-bold text-sm mb-2">Ulangi Kata Sandi Baru</div>
                                    <div class="input-icon mb-3">
                                        <input class="form-control m-0" type="text" placeholder="Masukan kata sandi" v-model="form.retype_password">
                                        <i class="fa-solid fa-lock text-muted"></i>
                                    </div>
                                    <small class="text-danger" v-if="(form.new_password != form.retype_password && form.retype_password != '')">Kata sandi baru tidak sesuai</small>
                                </div>
                                <div class="d-block small text-muted pt-3">Isi kata sandi dengan kombinasi huruf besar kecil
                                    dan angka, minimal 8 karakter</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'StudentPromotion',
        data() {
            return {
                dataFetch   : false,
                dataUsers   : {
                    rationalization : {
                        university_one : '',
                        major_one : '',
                        university_two : '',
                        major_two : ''
                    }
                },
                form : {
                    id : '',
                    fullname : '',
                    identity_number : '',
                    class : '',
                    old_password : '',
                    new_password : '',
                    retype_password : ''
                },
                waiting         : false                
            }
        }
        ,
        created() {
            this.getData();
        },
        methods: {
            goToPage: function (params = null) {
                this.$router.push({
                    name: params
                })
            },
            getData: function() {
                let uri         = process.env.VUE_APP_APIHOST+'users/my_profile';

                this.dataFetch  = true;                
                this.$http.get(uri).then(res => {
                    this.dataFetch = false;                
                    this.dataUsers = res.data.data;

                    this.form.id = this.dataUsers.id;
                    this.form.fullname = this.dataUsers.fullname;
                    this.form.identity_number = this.dataUsers.identity_number;
                    this.form.class = this.dataUsers.class;
                });
            },
            saveProfile: function() {
                if(this.form.new_password != this.form.retype_password) {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Password baru yang dimasukan tidak sama!',
                    });
                } else {
                    let formData = new FormData();
                    for (let key in this.form) {
                        formData.append(key, this.form[key]);
                    }

                    this.$http.post(process.env.VUE_APP_APIHOST + 'users/save_profile', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                        if (response.data.status) {
                            this.$swal({
                                icon: 'success',
                                title: 'Success',
                                text: response.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.getData();
                                    this.form.old_password = ""
                                    this.form.new_password = ""
                                    this.form.retype_password = ""
                                }
                            });
                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: response.data.message,
                            });
                        }
                        this.waiting = false;
                    })
                    .catch(function () {
                        this.$swal({
                            icon: 'warning',
                            title: 'Ups!',
                            text: 'Please check your internet connection.',
                        });
                        this.waiting = false;
                        return;
                    });
                }
            }
        }
    }
</script>